/*!
 *
 *	menu.js
 *
 */

var scrollPos;

$.fn.menu = function(){

	$('#menu').addClass('st-Menu-init');

	var $btn = $(this);

	$('#menu').find('a').on('click', function(){
		$btn.removeClass('active');
		$('#menu').removeClass('st-Menu-visible');
		$('body').css({
			position: 'static',
			top: 0
		});
		window.scrollTo(0, scrollPos);
	})

	$(this).on('tap', function(e){
		e.preventDefault();
		var _target = $(this).attr('href');
		$(this).toggleClass('active');
		if ($(_target).is('.st-Menu-visible') ){
			$(_target).removeClass('st-Menu-visible');
			$('body').css({
				position: 'static',
				top: 0
			});
			window.scrollTo(0, scrollPos);
		}else{
			scrollPos = $(window).scrollTop();
			$('body').css({
				position: 'fixed',
				top: -scrollPos
			});
			$(_target).addClass('st-Menu-visible');
		}
	});
};


//////////////////
// WEBPACK FOOTER
// ./dev/js/module/menu.js
// module id = 17
// module chunks = 0 1